class WiQuickAdd extends HTMLElement {
    constructor() {
        super();
        this.quickAddPressed = false; // Flag to track if event listener is added
    }

    connectedCallback() {
        if (!this.quickAddPressed) {
            this.quickAddPress();
            this.quickAddPressed = true; // Set the flag to true after adding the event listener
        }
    }

    // Click on quick add button 
    quickAddPress() {
        this.addEventListener('click', async (e) => {
            e.preventDefault();
            let variantID = this.getAttribute('data-varID');
            let formData = {
                'items': [{
                    'id': variantID,
                    'quantity': 1
                }]
            };
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                document.dispatchEvent(new CustomEvent('quickadd:added', { bubbles: false }));
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });
    }
}

customElements.define('wi-quickadd', WiQuickAdd);
